import { createSlice } from '@reduxjs/toolkit';
import { OrderMessagesOnExpeditionBoxDetailStateType } from 'src/types/orderMessagesOnExpeditionBoxDetail';

const initialState: OrderMessagesOnExpeditionBoxDetailStateType = {
    data: null,
    loading: false,
    deleted: false,
    error: false,
};
export const orderMessagesOnExpeditionBoxDetailSlice = createSlice({
    name: 'orderMessagesOnExpeditionBoxDetail',
    initialState,
    reducers: {
        getOrderMessagesOnExpeditionBoxDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getOrderMessagesOnExpeditionBoxDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getOrderMessagesOnExpeditionBoxDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createOrderMessagesOnExpeditionBoxDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createOrderMessagesOnExpeditionBoxDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        createOrderMessagesOnExpeditionBoxDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        updateOrderMessagesOnExpeditionBoxDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateOrderMessagesOnExpeditionBoxDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateOrderMessagesOnExpeditionBoxDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        deleteOrderMessagesOnExpeditionBoxDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deleteOrderMessagesOnExpeditionBoxDetailFetchSuccess: (state, action) => {
            state.deleted = true;
            state.loading = false;
        },
        deleteOrderMessagesOnExpeditionBoxDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        clearOrderMessagesOnExpeditionBoxDetail: () => initialState,
    },
});

export const {
    getOrderMessagesOnExpeditionBoxDetailFetch,
    getOrderMessagesOnExpeditionBoxDetailFetchSuccess,
    getOrderMessagesOnExpeditionBoxDetailFetchFailure,
    updateOrderMessagesOnExpeditionBoxDetailFetch,
    updateOrderMessagesOnExpeditionBoxDetailFetchSuccess,
    updateOrderMessagesOnExpeditionBoxDetailFetchFailure,
    createOrderMessagesOnExpeditionBoxDetailFetch,
    createOrderMessagesOnExpeditionBoxDetailFetchSuccess,
    createOrderMessagesOnExpeditionBoxDetailFetchFailure,
    deleteOrderMessagesOnExpeditionBoxDetailFetch,
    deleteOrderMessagesOnExpeditionBoxDetailFetchSuccess,
    deleteOrderMessagesOnExpeditionBoxDetailFetchFailure,
    clearOrderMessagesOnExpeditionBoxDetail,
} = orderMessagesOnExpeditionBoxDetailSlice.actions;

export default orderMessagesOnExpeditionBoxDetailSlice.reducer;
